<template>
	<v-container>
		<div class="toolbarheader" >

			<div>
				<img class="imageheader" src="@/assets/logo-tauli.png">
			</div>
			<div>
				<v-text-field           
				outlined
				clearable             
				type="text"
				placeholder="Buscador"
				append-icon="mdi-magnify"
				>

			</v-text-field>

		</div>
		<div class="date">DEC 17 2020</div>

	</div>	
	<div class="titleBar">
		<div class="row">
			<v-col cols="12" md="9">
				<h1>ARA STATION - CLINICAL WORK EMERGENCIES</h1>
			</v-col> 
			<v-col cols="6" md="1">
				<v-select label="English" :items="langItems" outlined>
				</v-select>
			</v-col>
			<v-col class="boxName" cols="6" md="2">
				<div>
					<v-row>
						<v-col cols="4" md="5"  >
							<div class="headline">MAR LÓPEZ </div>
							<span class="grey--text">3581</span>
						</v-col>
						<v-col cols="1" md="1" >
							<v-icon  large>mdi-account</v-icon>
						</v-col>
					</v-row> 
				</div>
			</v-col>
		</div>
	</div>
	<div class="barMenu">
		<div class="container">
			<div class="flex flex-row barMenu-flex">
				<button class="btn-menu">Acces to HC</button>
				<button class="btn-menu">Activity Register</button>
				<button class="btn-menu">Last Clinical Records</button>
				<button class="btn-menu">Patient Activity</button>
			</div>
		</div>
	</div>
	<v-row>
		<v-col class="content" cols="12" xs="12" sm="12" md="6">
			<h2>REASON FOR CONSULTATION</h2>

			<v-row>
				<v-col>
					<v-text-field
					name="name"
					label="DYSPNOEA"
					outlined
					id="id"
					>DYSPNOEA</v-text-field>
					<div class="tree">


						<div class="treePatology">
							<ul class="list list-1 firstchild showList ">
								<li class="item-2 " id="item-2" data-orderlist="1">
									<a href="" class="" > Acute dyspnea  </a>

									<ul class="list list-2  showList">
										<li class="item-1024 " id="item-1024" data-orderlist="0">
											<a href="" class="" > Pulmonary embolism  </a>

										</li>
										<li class="item-96 " id="item-96" data-orderlist="1">
											<a href="" class="" > Occupation of the bronchial and / or alveolar lumen  </a>

											<ul class="list list-96  showList">
												<li class="item-97 " id="item-97" data-orderlist="0">
													<a href="" class="" > Typical pneumonia  </a>

												</li>
												<li class="item-98 " id="item-98" data-orderlist="1">
													<a href="" class="" > Atypical pneumonia  </a>

												</li>
												<li class="item-99 " id="item-99" data-orderlist="2">
													<a href="" class="" > Pulmonary hemorrhage  </a>

												</li>
												<li class="item-100 " id="item-100" data-orderlist="3">
													<a href="" class="" > Aspiration pneumonia  </a>

												</li>
												<li class="item-101 " id="item-101" data-orderlist="4">
													<a href="" class="" > Bronchospasm  </a>

													<ul class="list list-101  showList">
														<li class="item-1053 " id="item-1053" data-orderlist="0">
															<a href="" class="" > Asthma  </a>

														</li>
														<li class="item-1054 " id="item-1054" data-orderlist="1">
															<a href="" class="" > Chronic Obstructive Pulmonary Disease (COPD)  </a>

														</li>
													</ul>

												</li>
												<li class="item-109 " id="item-109" data-orderlist="5">
													<a href="" class="" > Cardiogenic pulmonary edema  </a>

												</li>
												<li class="item-1055 " id="item-1055" data-orderlist="6">
													<a href="" class="" > Adult respiratory distress syndrome (respiratory distress)  </a>

												</li>
												<li class="item-1280 " id="item-1280" data-orderlist="7">
													<a href="" class="" > COVID-19  </a>

												</li>
											</ul>

										</li>
										<li class="item-102 " id="item-102" data-orderlist="2">
											<a href=" " class="" >Pleural space occupation </a>

											<ul class="list list-102  showList">
												<li class="item-103 " id="item-103" data-orderlist="0">
													<a href=" " class="" > Pleural effusion  </a>

												</li>
												<li class="item-104 " id="item-104" data-orderlist="1">
													<a href="" class="" > Spontaneous pneumothorax  </a>

												</li>
											</ul>

										</li>
										<li class="item-1091 " id="item-1091" data-orderlist="3">
											<a href="" class="" > Extrapulmonary origin  </a>

											<ul class="list list-1091  showList">
												<li class="item-111 " id="item-111" data-orderlist="0">
													<a href="" class="" > Metabolic acidosis </a>

												</li>
												<li class="item-1056 " id="item-1056" data-orderlist="1">
													<a href="" class="" > Anxiety  </a>

												</li>
											</ul>

										</li>
									</ul>

								</li>
								<li class="item-112 " id="item-112" data-orderlist="1">
									<a href="" class="" > Chronic dyspnea  </a>

									<ul class="list list-112  showList">
										<li class="item-113 " id="item-113" data-orderlist="3">
											<a href="" class="" > Obstructive diseases </a>

											<ul class="list list-113  showList">
												<li class="item-954 " id="item-954" data-orderlist="0">
													<a href="" class="" > Chronic Obstructive Pulmonary Disease (COPD)  </a>

												</li>
												<li class="item-116 " id="item-116" data-orderlist="1">
													<a href="" class="" > Asthma  </a>

												</li>
											</ul>

										</li>
										<li class="item-117 " id="item-117" data-orderlist="3">
											<a href="" class="" > Restrictive diseases  </a>

											<ul class="list list-117  showList">
												<li class="item-118 " id="item-118" data-orderlist="0">
													<a href="" class="" > Interstitial lung disease  </a>

												</li>
												<li class="item-119 " id="item-119" data-orderlist="1">
													<a href="" class="" > Chest wall deformity  </a>

												</li>
												<li class="item-120 " id="item-120" data-orderlist="2">
													<a href="" class="" > Obesity  </a>

												</li>
												<li class="item-122 " id="item-122" data-orderlist="4">
													<a href="" class="" > Motor neuron diseases  </a>

													<ul class="list list-122  showList">
														<li class="item-123 " id="item-123" data-orderlist="0">
															<a href="" class="" > Duchenne disease  </a>

														</li>
														<li class="item-124 " id="item-124" data-orderlist="1">
															<a href="" class="" > Amyotrophic Lateral Sclerosis  </a>

														</li>
														<li class="item-125 " id="item-125" data-orderlist="2">
															<a href="" class="" > Progressive bulbar palsy  </a>

														</li>
														<li class="item-126 " id="item-126" data-orderlist="3">
															<a href="" class="" > Hereditary neuropathies  </a>

															<ul class="list list-126  showList">
																<li class="item-1174 " id="item-1174" data-orderlist="0">
																	<a href="" class="" > Charcot-Marie-Tooth disease  </a>

																</li>
																<li class="item-1175 " id="item-1175" data-orderlist="1">
																	<a href="" class="" >Hereditary sensory neuropathy  </a>

																</li>
															</ul>

														</li>
														<li class="item-127 " id="item-127" data-orderlist="4">
															<a href="" class="" > Guillain Barre syndrome  </a>

														</li>
														<li class="item-128 " id="item-128" data-orderlist="5">
															<a href="" class="" > Myasthenia gravis  </a>

														</li>
													</ul>

												</li>
												<li class="item-121 " id="item-121" data-orderlist="5">
													<a href="" class="" > Pleural fibrosis  </a>

												</li>
											</ul>

										</li>
										<li class="item-129 " id="item-129" data-orderlist="3">
											<a href="" class="" > Extrapulmonary origin  </a>

											<ul class="list list-129  showList">
												<li class="item-135 " id="item-135" data-orderlist="0">
													<a href=" " class="" > Heart failure  </a>

												</li>
												<li class="item-137 " id="item-137" data-orderlist="1">
													<a href="" class="" > Valvular dysfunctions  </a>

													<ul class="list list-137  showList">
														<li class="item-1059 " id="item-1059" data-orderlist="0">
															<a href="" class="" > Aortic valve stenosis  </a>

														</li>
														<li class="item-1060 " id="item-1060" data-orderlist="1">
															<a href="" class="" > Aortic insufficiency  </a>

														</li>
														<li class="item-1061 " id="item-1061" data-orderlist="2">
															<a href="" class="" > Estenosis mitral  </a>

														</li>
														<li class="item-1062 " id="item-1062" data-orderlist="3">
															<a href="" class="" > Mitral regurgitation   </a>

														</li>
													</ul>

												</li>
												<li class="item-138 " id="item-138" data-orderlist="2">
													<a href="/es/proceso-clinico/detail?show=138" class="" > Arrhythmias  </a>

													<ul class="list list-138  showList">
														<li class="item-1064 " id="item-1064" data-orderlist="0">
															<a href="/es/proceso-clinico/detail?show=1064" class="" > Bradyarrhythmias  </a>

															<ul class="list list-1064  showList">
																<li class="item-1066 " id="item-1066" data-orderlist="0">
																	<a href="/es/proceso-clinico/detail?show=1066" class="" > Sinus bradycardia </a>

																</li>
																<li class="item-1067 " id="item-1067" data-orderlist="1">
																	<a href="/es/proceso-clinico/detail?show=1067" class="" > First degree atrio-ventricular block  </a>

																</li>
																<li class="item-1068 " id="item-1068" data-orderlist="2">
																	<a href="/es/proceso-clinico/detail?show=1068" class="" > Second-degree atrioventricular block  </a>

																</li>
																<li class="item-1069 " id="item-1069" data-orderlist="3">
																	<a href="/es/proceso-clinico/detail?show=1069" class="" >Complete atrio-ventricular block </a>

																</li>
															</ul>

														</li>
														<li class="item-1065 " id="item-1065" data-orderlist="1">
															<a href="/es/proceso-clinico/detail?show=1065" class="" > Tachyarrhythmias  </a>

															<ul class="list list-1065  showList">
																<li class="item-1070 " id="item-1070" data-orderlist="0">
																	<a href="/es/proceso-clinico/detail?show=1070" class="" > Sinus tachycardia  </a>

																</li>
																<li class="item-1071 " id="item-1071" data-orderlist="1">
																	<a href="/es/proceso-clinico/detail?show=1071" class="" > Atrial flutter </a>

																</li>
																<li class="item-1072 " id="item-1072" data-orderlist="2">
																	<a href="/es/proceso-clinico/detail?show=1072" class="" > Atrial fibrillation  </a>

																</li>
																<li class="item-1073 " id="item-1073" data-orderlist="3">
																	<a href="/es/proceso-clinico/detail?show=1073" class="" > Paroxysmal supraventricular tachycardia  </a>

																</li>
																<li class="item-1074 " id="item-1074" data-orderlist="4">
																	<a href="/es/proceso-clinico/detail?show=1074" class="" > Ventricular tachycardia  </a>

																</li>
																<li class="item-1075 " id="item-1075" data-orderlist="5">
																	<a href="/es/proceso-clinico/detail?show=1075" class="" > Ventricular fibrillation  </a>

																</li>
															</ul>

														</li>
													</ul>

												</li>
												<li class="item-139 " id="item-139" data-orderlist="3">
													<a href="/es/proceso-clinico/detail?show=139" class="" > Anemia  </a>

												</li>
												<li class="item-140 " id="item-140" data-orderlist="4">
													<a href="/es/proceso-clinico/detail?show=140" class="" > Hyperthyroidism  </a>

												</li>
												<li class="item-141 " id="item-141" data-orderlist="5">
													<a href="/es/proceso-clinico/detail?show=141" class="" >Upper respiratory diseases </a>

													<ul class="list list-141  showList">
														<li class="item-1176 " id="item-1176" data-orderlist="0">
															<a href="/es/proceso-clinico/detail?show=1176" class="" > Acute laryngitis and tracheitis  </a>

														</li>
													</ul>

												</li>
												<li class="item-1063 " id="item-1063" data-orderlist="6">
													<a href="/es/proceso-clinico/detail?show=1063" class="" > Anxiety  </a>

												</li>
												<li class="item-143 " id="item-143" data-orderlist="7">
													<a href="/es/proceso-clinico/detail?show=143" class="" > Depression  </a>

												</li>
												<li class="item-145 " id="item-145" data-orderlist="8">
													<a href="/es/proceso-clinico/detail?show=145" class="" > Gastroesophageal reflux  </a>

												</li>
												<li class="item-146 " id="item-146" data-orderlist="9">
													<a href="/es/proceso-clinico/detail?show=146" class="" > Ascites  </a>

												</li>
												<li class="item-147 " id="item-147" data-orderlist="10">
													<a href="/es/proceso-clinico/detail?show=147" class="" > Abdominal mass </a>

												</li>
											</ul>

										</li>
										<li class="item-148 " id="item-148" data-orderlist="3">
											<a href="/es/proceso-clinico/detail?show=148" class="" > Pulmonary vascular diseases  </a>

											<ul class="list list-148  showList">
												<li class="item-149 " id="item-149" data-orderlist="0">
													<a href="/es/proceso-clinico/detail?show=149" class="" > Chronic pulmonary embolism   </a>

												</li>
												<li class="item-150 " id="item-150" data-orderlist="2">
													<a href="/es/proceso-clinico/detail?show=150" class="" > Pulmonary Hieprtension  </a>

												</li>
												<li class="item-151 " id="item-151" data-orderlist="2">
													<a href="/es/proceso-clinico/detail?show=151" class="" > Pulmonary arteriovenous malformation  </a>

												</li>
												<li class="item-152 " id="item-152" data-orderlist="3">
													<a href="/es/proceso-clinico/detail?show=152" class="" > Vasculitis with pulmonary involvement </a>

													<ul class="list list-152  showList">
														<li class="item-1076 " id="item-1076" data-orderlist="0">
															<a href="/es/proceso-clinico/detail?show=1076" class="" > Churg-Strauss  disease </a>

														</li>
														<li class="item-1077 " id="item-1077" data-orderlist="1">
															<a href="/es/proceso-clinico/detail?show=1077" class="" >Wegener's granulomatosis </a>

														</li>
														<li class="item-1078 " id="item-1078" data-orderlist="2">
															<a href="/es/proceso-clinico/detail?show=1078" class="" > Microscopic polyangiitis  </a>

														</li>
														<li class="item-1080 " id="item-1080" data-orderlist="3">
															<a href="/es/proceso-clinico/detail?show=1080" class="" > Takayasu arteritis </a>

														</li>
														<li class="item-1082 " id="item-1082" data-orderlist="4">
															<a href="/es/proceso-clinico/detail?show=1082" class="" > Cryoglobulinemia  </a>

														</li>
														<li class="item-1083 " id="item-1083" data-orderlist="5">
															<a href="/es/proceso-clinico/detail?show=1083" class="" > Polyarteritis nodosa  </a>

														</li>
														<li class="item-1084 " id="item-1084" data-orderlist="6">
															<a href="/es/proceso-clinico/detail?show=1084" class="" > Behçet's disease  </a>

														</li>
														<li class="item-1085 " id="item-1085" data-orderlist="7">
															<a href="/es/proceso-clinico/detail?show=1085" class="" > Giant cell arteritis and polymyalgia rheumatica  </a>

														</li>
														<li class="item-1086 " id="item-1086" data-orderlist="8">
															<a href="/es/proceso-clinico/detail?show=1086" class="" > IgA vasculitis (Henoch-Schönlein purpura)  </a>

														</li>
													</ul>

												</li>
											</ul>

										</li>
									</ul>

								</li>
							</ul>
						</div>



					</div>
					<div class="data-pc">


					</div>
				</v-col>
				<v-col class="info-pacient ">
					<template>
						<v-expansion-panels>
							<v-expansion-panel
							v-for="(item,i) in expansionDisnea"
							vue		:key="i"
							>
							<v-expansion-panel-header v-if="item.id!=3">
								{{ item.title }}
							</v-expansion-panel-header>
							<v-expansion-panel-header hide-actions v-else   :class="{antecedentesActive:antecedentesShow}" @click="antecedentesShow = !antecedentesShow">{{ item.title }}</v-expansion-panel-header>

						</v-expansion-panel>
					</v-expansion-panels>
				</template>

			</v-col>
		</v-row>
	</v-col>
	<v-col cols="12"  xs="12" sm="12" md="6" v-if="antecedentesShow"  class="antecedentesDetail  ">
		<v-card class="cardPatient">
			<h3>Antecedentes</h3>
			<div class="cards" > 
				<v-card outlined class="mx-auto"
				>
				<v-list-item three-line>
					<v-list-item-content>											 
						<v-list-item-title class="headline mb-1">
							<h5>Pathological Background</h5>
						</v-list-item-title>
						<div class="text--primary">
							<ul>
								<li>Alcoholism</li>
								<li>Asthma</li>
								<li>Inmunosuppression</li>
								<li>Bronchiectasis </li>
							</ul>
						</div>
					</v-list-item-content>

				</v-list-item>
			</v-card>
			<v-card outlined class="mx-auto"
			>
			<v-list-item three-line>
				<v-list-item-content>											 
					<v-list-item-title class="headline mb-1">
						<h5>Condition</h5>	
					</v-list-item-title>
					<div class="text--primary">
						<ul>
							<li>Over 70 years</li>
							<li>Asthma</li>
							<li>Inmunosuppression</li>
						</ul>
					</div>
				</v-list-item-content>

			</v-list-item>
		</v-card>
		<v-card outlined class="mx-auto"
		>
		<v-list-item three-line>
			<v-list-item-content>											 
				<v-list-item-title class="headline mb-1">
					<h5>Toxical Habits</h5>		
				</v-list-item-title>
				<div class="text--primary">
					<ul>
						<li>Alcoholism</li> 
						<li> Smoking</li>
						<li> COPD</li>
					</ul>
				</div>
			</v-list-item-content>

		</v-list-item>
	</v-card>


</div>
</v-card>


</v-col>
<v-col class="patientInfo" cols="12" xs="12" sm="12" md="6" v-if="!antecedentesShow">
	<v-card class="cardPatient">
		<div class="row">
			<v-col cols="12" sm="8">
				<div class="cardrow">
					<v-col>PATIENT NUMBER:</v-col>
					<v-col> ABCD9919K</v-col>
				</div>
				<div class="cardrow">
					<h3>PETER MOUNTAIN</h3>
				</div>
				<div class="cardrow">
					<v-col>TOWN:</v-col>
					<v-col>SABADELL</v-col>
				</div>
				<div class="cardrow">
					<v-col>
						H.C.N:
					</v-col>
					<v-col>
						zzfl143-19
					</v-col>
				</div>
				<div class="cardrow">
					<v-col>ALLERGIES:</v-col>
					<v-col>Aspirin</v-col>
				</div>
				<div class="cardrow">
					<v-col>Last Diagnosis:</v-col>
					<v-col>Right Arm Trauma</v-col>
				</div>
				<div class="cardrow">
					<v-col>Bckground:</v-col>
					<v-col>High Tension</v-col>
				</div>
				<div class="cardrow">
					<v-col>Doctor:</v-col>
					<v-col>Escamilla E.</v-col>
				</div>
			</v-col>
			<v-col cols="12" sm="4" class="motivo-inicial" >
				<div class=" ">
					Initial Reason : DIZZINESS
				</div>
				<div class=" ">
					Age: 51
				</div>

				<div class="">
					<img src="@/assets/paciente.jpg" alt="" width="100%">
				</div>

			</v-col>
		</div>
	</v-card>
</v-col>
</v-row>

<!-------->
<v-row>	

	<v-card class="datadetailClinica" v-if="showDetailClinica">	
		<div class="closeDetailClinica" style="position:relative;float:right;cursor:pointer"   @click="showDetailClinica = !showDetailClinica"> <v-icon medium> mdi-close </v-icon></div>
		<div style="display:flex;flex-direction:row;align-items:center;justify-content:center">
			<h3>Síntomas</h3>
			<v-text-field class="col-md-2"
			placeholder="Buscador"						 
			></v-text-field>
		</div>
		<div class="boxDetailClinica">
			<div class="arrow"> <v-icon>mdi-menu-left</v-icon> </div>
			<div>
				<v-card outlined class="mx-auto"
				>
				<v-list-item three-line>
					<v-list-item-content>											 
						<v-list-item-title class="headline mb-1">
							<h5>FIEBRE</h5>		
						</v-list-item-title>
						<div class="text--primary">
							
							<v-chip>R50 - FIEBRE DE OTRO ORIGEN Y DE ORIGEN DESCONOCIDO</v-chip>
							<v-chip>R50.9 - Fiebre, no especificada</v-chip>
							<v-chip>R50.81 - Fiebre asociada a afecciones clasificadas bajo otr..</v-chip>
							

						</div>
						<div class="text--primary">
							<ul>
								<li>Subclasificación:  Neumonía Típica</li> 
								<li>Frecuencia: Muy frecuente</li>
								<li>Forma de Inicio: Brusca</li>						 
							</ul>
						</div> 
					</v-list-item-content>

				</v-list-item>
			</v-card>
		</div>
		<div>
			<v-card outlined class="mx-auto"
			>
			<v-list-item three-line>
				<v-list-item-content>											 
					<v-list-item-title class="headline mb-1">
						<h5>Tos</h5>		
					</v-list-item-title>
					<div class="text--primary">

						<v-chip> R05- Tos</v-chip>					 
						<v-chip> R04.2- Hemoptisis</v-chip>
						<v-chip> J41.0- Bronquitis Crónica Simple</v-chip>

					</div>
					<div class="text--primary">
						<ul>						 
							<li>Frecuencia: Muy frecuente</li>
							<li> Forma de Inicio: Brusca</li>
						</ul>
					</div>
				</v-list-item-content>

			</v-list-item>
		</v-card>
	</div>
	<div>
		<v-card outlined class="mx-auto"
		>
		<v-list-item three-line>
			<v-list-item-content>											 
				<v-list-item-title class="headline mb-1">
					<h5>Expectoración purulenta</h5>		
				</v-list-item-title>


				<div class="text--primary">
					<ul>
						<li>Sinónimos:

							Esputo Amarillo,
							Esputo Verde,
							Esputo oscuro
						</li>
					</ul>
				</div>
				<div class="text--primary">
					<ul>
						<li>Frecuencia: Muy frecuente</li>
						<li>Forma de Inicio: Brusca</li> </ul>
					</div>

				</v-list-item-content>

			</v-list-item>
		</v-card>
	</div>
	<div class="arrow">
		<v-icon>mdi-menu-right</v-icon>  
	</div>
</div>


<div style="display:flex;flex-direction:row;align-items:center;justify-content:center">
	<h3>SIGNOS</h3>
	<v-text-field class="col-md-2"
	placeholder="Buscador"						 
	></v-text-field>
</div>
<div class="boxDetailClinica">
	<div class="arrow"> <v-icon>mdi-menu-left</v-icon> </div>
	<div>
		<v-card outlined class="mx-auto"
		>
		<v-list-item three-line>
			<v-list-item-content>											 
				<v-list-item-title class="headline mb-1">
					<h5>Crepitantes</h5>		
				</v-list-item-title>

				<div class="text--primary">
					<ul>	
						<li>Descripción: -						 </li>
						<li>Valores: -						 </li>			 
						<li>Frecuencia:   frecuente</li>
					</ul>
				</div> 
			</v-list-item-content>

		</v-list-item>
	</v-card>
</div>
<div>
	<v-card outlined class="mx-auto"
	>
	<v-list-item three-line>
		<v-list-item-content>											 
			<v-list-item-title class="headline mb-1">
				<h5>Taquicardia </h5>		
			</v-list-item-title>
			<div class="text--primary">

				<v-chip> R00.0 - Taquicardia, no especificada.</v-chip>					 


			</div>
			<div class="text--primary">
				<ul><li>Asociación con:  Fiebre,
				Sepsis grave con shock séptico</li>
			</ul>


		</div>
		<div class="text--primary">
			<ul>
				<li>Descripción: -						 </li>
				<li>Valores: -						 </li>
				<li>Frecuencia: Frecuente</li>
			</ul>
		</div>
	</v-list-item-content>

</v-list-item>
</v-card>
</div>
<div>
	<v-card outlined class="mx-auto"
	>
	<v-list-item three-line>
		<v-list-item-content>											 
			<v-list-item-title class="headline mb-1">
				<h5>Hipotensión arterial </h5>		
			</v-list-item-title>
			
			
			<div class="text--primary">
				<ul>
					<li>Sinónimos:

						Esputo Amarillo,
						Esputo Verde,
						Esputo oscuro
					</li>
				</ul>
			</div>
			<div class="text--primary">
				<ul>
					<li>Descripción: -						 </li>
					<li>Valores: -						 </li>
					<li>Frecuencia: Raro</li>	
					<li>Asociación con: Sepsis grave con shock séptico				</li>
				</ul>
			</div>

		</v-list-item-content>

	</v-list-item>
</v-card>
</div>
<div class="arrow">
	<v-icon>mdi-menu-right</v-icon>  
</div>
</div>




</v-card>
</v-row>
<div class="datadetail" v-if="!showDetailClinica">	
	<div class="columns-data" @click="showDetailClinica = !showDetailClinica">
		<h2>Clínic</h2>
		<h2>Symptoms</h2>
		<h2>Signs</h2>
	</div>

	<div  class="columns-data">
		<h2>Tests</h2>
		<h2>Analytics</h2>
		<h2>Radiology</h2>
	</div>

	<div class="columns-data">
		<h2>Prediagnosis</h2>
		<h2>Therapeutic</h2>
	</div>
</div>
<v-row>

</v-row>

<v-footer>	
	<ul class="breadcrumbs">
		<li>
			<a class="completed">
				<span class="number">1</span>
				REC
			</a>
		</li>
		<li>
			<a class="completed">
				<span class="number">2</span>
				EVA
			</a>
		</li>
		<li>
			<a class="current">
				<span class="number">3</span>
				PRV
			</a>
		</li>
		<li>
			<a>
				<span class="number">4</span>
				TMAPV
			</a>
		</li>
		<li>
			<a>
				<span class="number">5</span>
				PRU
			</a>
		</li>
		<li>
			<a>
				<span class="number">5</span>
				RES
			</a>
		</li>
	</ul>


	<div class="footertop">
		<ul class="nav MenuPeu">
			<li class="item-517">
				<a accesskey="0" href="">Accessibility</a>
			</li>
			<li class="item-519">
				<a accesskey="7" href="">Legal Warning</a>
			</li>
			<li class="item-521">
				<a accesskey="" href="">Privacy Policy</a>
			</li>
			<li class="item-520">
				<a accesskey="" href=" ">Map</a>
			</li>
		</ul>
	</div>	
	<div class="subfooter logos">
		<img class="imgLogo" src="@/assets/logo-generalitat.png">
		<img class="imgLogo" src="@/assets/FEDER7.png" alt="">
	</div>
</v-footer>

</v-container>
</template>
<style lang="scss">
:root{
--maincolorbreadcrumb: 225;
--percentbr: 85%;
}
.boxDetailClinica{
	.text--primary {


	.v-chip{
	height:auto!important;
	margin: 8px!important;
	
}
}
}

.antecedentesDetail{
	border: 1px solid lightgray;
	border-radius:20px;
	margin-bottom:20px;
}
.antecedentesActive{
	background-color:  #36699C;
	color:white!important;
	
}

footer{
	margin-top:20px;
}

.footertop{
	width: 100%;
	margin-bottom:30px;
	.MenuPeu{
	list-style:none;
	justify-content:space-around;
	display: flex;
	flex-direction:row;
	width: 40%;margin:auto;
	@media screen and (max-width:768px){
	flex-direction:column;
}
}
}
.subfooter{
	margin-top:20px;
	width: 50%;
	margin:auto;
	&.logos{
	width: 40%;
	margin: auto;
	text-align: center;
	@media screen and (max-width:768px){
	width: 80%;
	flex-direction:column;
}
}
.imgLogo{
	height:40px;
	width: auto;
	margin-right:20px;

}
}
.cards{
	display:grid; grid-template-columns:1fr 1fr; grid-gap: 20px;
	@media screen and(max-width: 768px){
	grid-template-columns:1fr;
}

}
.cardrow{
	display: grid;
	grid-template-columns: 1fr 1fr;
}
.cardPatient{
	padding:20px;
}
.flex{display:flex;}
	.flex-row{flex-direction: row;}
	.titleBar{
	
	color: #36699C;
	padding:10px;
	@media screen and (max-width:768px){
	h1{
	font-size:1.5rem;
}
}
}
.barMenu-flex {
	flex-wrap: wrap!important;


}
.barMenu{
	//background-color:#333;
	//color:white;
	display: flex;
	flex-direction:row;
	align-items: center;
	justify-content: space-around;
	button{
	border:1px solid #36699C;
	border-radius: 30px;
	padding:10px;
	box-shadow: 2px 2px 1px  #36699C;
}
}
.btn-menu{
	text-transform: uppercase;
	font-size:16px;
	margin-right:20px;
	margin-top:10px;
	@media screen and (max-width:768px){
	font-size:12px;

}

}

.toolbarheader{	 
	background-image: linear-gradient(left, #ffffff 1%, #99ccff 99%);	 
	height: 100px;
	display:grid;
	grid-template-columns: 200px 1fr 200px;
	grid-gap:40px;
	@media screen and (max-width:768px){
	grid-template-columns:3fr 2fr 1fr;
}
> div{
display: flex;
flex-direction:column;
justify-content:center;

}
.boxName{
	border:  1px solid lightgray;
	width: auto;
}

.v-input__slot{
	margin-top:20px;
}
}
.autocompleteDiv{
	width: 50%;
	text-align:center;
	margin:auto;
}
.v-toolbar__content{
	height:100px!important;
}
.imageheader{
	height:auto;
	width: 100%;
	margin:10px;
}

.tree{
	margin: 0 5px;
	display: block;
	a{text-decoration:none; color:inherit;}
	ul {
	margin-left: 2em;
	position: relative;
}
> li {
border-bottom: 1px solid lightgray;
padding: 10px 0;
}
li{
	position: relative
}
}

.treePatology{
	overflow-y:scroll;
	height:300px;
}

.date{
	font-size:20px;
}




.columns-data{
	border:1px solid lightgray;
	padding:10px 20px;
}
.datadetail{
	display: grid;
	grid-template-columns: 3fr 3fr 6fr;
	grid-gap:20px;
	@media screen and (max-width:768px){
	grid-template-columns:1fr;
}
}
.datadetailClinica{
	padding:20px 10%;
	border:1px solid lightgray;

}
.boxDetailClinica{
	display:grid; grid-template-columns: 50px repeat(3,1fr) 50px; grid-gap:10px;
	@media screen and (max-width:768px	){
	grid-template-columns:1fr;
}

}
.arrow{
	display: flex;
	flex-direction:column;
	align-items:center;
	justify-content:center;
	font-size:40px;
}



/*********************************/
/*********************************/

$incomplete: #000;
$completed: #36699C;
$current: lighten(#FF0000, 15%);
$pulse-length: 1s;

ul.breadcrumbs {
	margin:   50px auto;
	list-style: none;

	&:after {
	clear: both;
	content: "";
	display: table; 
}

& li {
	display: block;
	float: left;
	margin: 0px;
	padding: 0px;

	& a {
	cursor: pointer;
	display: inline-block;
	background-color: $incomplete;
	color: white;
	line-height: 40px;
	padding: 0 35px 0 50px;
	position: relative;
	box-shadow: 0px 0px 10px $incomplete;

	&:after, &:before {
	display: block;
	position: absolute;
	content: "";
	background-color: $incomplete;
}

&:after {
	right: -15px;
	height: 28.5px;
	width: 28.5px;
	top: 4px;
	z-index: 5;
	transform: rotate(45deg);
	border-right: 3px white solid;
	border-top: 3px white solid;
	border-radius: 3px;
}

&:before {
	right: 3px;
	width: 30px;
	height: 40px;
	z-index: 6;
}

& span.number {
	border-radius: 50%;
	display: inline-block;
	line-height: 20px;
	background-color: white;
	font-family: "athelas", serif;
	font-weight: bold;
	color: black;
	width: 20px;
	text-align: center;
	margin-right: 5px;
}

&.completed {
	background-color: $completed;
	color: black;
	box-shadow: 0px 0px 10px $completed;

	&:after, &:before {
	background-color: $completed;
}
}

&.current {
	background-color: $current;
	animation-duration: $pulse-length;
	animation-name: pulse, glowPulse;
	animation-direction: alternate;
	animation-iteration-count: infinite;
	box-shadow: 0px 0px 10px $current;

	&:after, &:before {
	background-color: $current;
	animation-duration: $pulse-length;
	animation-name: pulse;
	animation-direction: alternate;
	animation-iteration-count: infinite;
}

&:after {
	animation-name: pulse;
}
}

}

&:first-child a {
	padding: 0 35px;
	border-radius: auto auto auto 3px;
}

&:last-child  a{
	border-radius: auto 3px auto;

	&:after {
	display: none;
}
}

}
}

@keyframes pulse {
from {
background-color:$incomplete;
}

to {
background-color:$current;
}
}

@keyframes glowPulse {
from {
box-shadow: 0px 0px 10px $incomplete;
}

to {
box-shadow: 0px 0px 10px $current;
}
}


/*********************************/
/*********************************/

</style>
<script>

export default{
	name:'Home',	

	data:()=>({
		langItems:['Español','Français'],
		expansionDisnea:[
		{ 
			id:1,
			title: 'GENERAL INFORMATION'
		},
		{ 
			id:2,
			title: 'EPIDEMIOLOGICAL DATA'
		},
		{
			id:3,
			title: 'BACKGROUND'

		},
		{
			id:4,
			title:'ALGORITHMS',

		},

		{
			id:5 ,
			title: 'SCALES | SOURCES'}
			], 
			antecedentesShow:false,
			showDetailClinica:false,
			absolute: true,
			opacity:0.5,

		}),
	watch: {
		antecedenteShow (val) {
			val && setTimeout(() => {
				this.antecedenteShow = false
			}, 15000)
		},
	},

}
</script>